import { ClearFiltersRequestedEvent } from "@/events/ClearFiltersRequestedEvent";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";
import { FilterKey } from "@/models/FilterKey";
import { EventAggregationService } from "@/platform/EventAggregationService";
import { IEventAggregationService, ISubscriber } from "@studyportals/event-aggregation-service-interface";

export class ClearFilters implements ISubscriber<ClearFiltersRequestedEvent> {

	private readonly eventAggregationService: IEventAggregationService;
	private readonly filterProvider: IFilterProvider;
	private disposed = false;

	private readonly filtersWithSpecificClearProcess = [FilterKey.COUNTRY];

	public constructor(filterProvider: IFilterProvider, eventAggregationService?: IEventAggregationService) {
		this.eventAggregationService = eventAggregationService ?? EventAggregationService.instance;
		this.eventAggregationService.subscribeTo(ClearFiltersRequestedEvent.EventType, this);
		this.filterProvider = filterProvider;
	}

	public dispose(): void {
		this.disposed = true;
	}

	public async notify(event: ClearFiltersRequestedEvent): Promise<void> {
		if (ClearFiltersRequestedEvent.is(event) && !this.disposed) {
			await this.clearFilters(event);
		}
	}

	public clearFilters = async (event: ClearFiltersRequestedEvent): Promise<void> => {
		const filters = event.filters.filter(filter => !this.filtersWithSpecificClearProcess.includes(filter.key));
		if (filters.length === 0) {
			return;
		}

		await this.filterProvider.clearSelection(filters);
	}

	public clearAll = async(filterKeys: FilterKey[]): Promise<void> => {
		await this.filterProvider.clearFilters(filterKeys);
	}
}
